import { connect } from 'react-redux';
import {
  addBidNote,
  bidFilterSet,
  downloadTourPdf,
  editBid,
  editGroup,
  messageSet,
  removeBid,
  requestBidsets,
  sendBid,
  sendHotelBidRequests,
  sendBidUpdate,
  sendToTourManager,
  setTourManagerSimMode,
  editMember,
  requestBidDetails,
  saveAddBookingData,
  updateReOpenBid,
  requestAnswers,
  ChangeBidDetail,
  changeBidDateDetail,
  editGroupEventOnManageBid,
  dispatchRemoveMemberFromManageBid,
  changeDateRoomType,
  addParticipantManageBid,
  selectEvent
} from '../modules/tour';

import ManageBids from './ManageBids';

const mapDispatchToProps = {
  addBidNote,
  bidFilterSet,
  downloadTourPdf,
  editBid,
  editGroup,
  messageSet,
  removeBid,
  requestBidsets,
  sendBid,
  sendHotelBidRequests,
  sendToTourManager,
  sendBidUpdate,
  setTourManagerSimMode,
  editMember,
  requestBidDetails,
  saveAddBookingData,
  updateReOpenBid,
  requestAnswers,
  ChangeBidDetail,
  changeBidDateDetail,
  editGroupEventOnManageBid,
  dispatchRemoveMemberFromManageBid,
  changeDateRoomType,
  addParticipantManageBid,
  selectEvent,
};

const mapStateToProps = state => ({
  bids: state.tours.selectedTour.bids,
  tour: state.tours.selectedTour.tour,
  proposals: state.tours.selectedTour.proposals,
  bidFilter: state.tours.selectedTour.bidFilter,
  needFetch: state.tours.selectedTour.fetches.bids.needFetch,
  isFetching: state.tours.selectedTour.fetches.bids.isFetching,
  user: state.auth.profile.user,
  bidbidsDetails: state.tours.bidbidsDetails,
  answers: state.tours.selectedAnswers,
  selectedEvent: state.tours.selectedTour.selectedEvent
});
const ManageBidsContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(ManageBids);
export default ManageBidsContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/ManageBidsContainer.js